export const LostInquiryLogPermissions = {
  GetAllLostInquiryLog: {
    permissionsId: '57ef6767-f39f-494e-794f-08dcaf947ea8',
    permissionsName: 'Get All Lost Inquiry Log',
    description: null,
    componentsId: null,
    components: null,
  },
};
